import mixpanel from 'mixpanel-browser';
import { getViteEnv } from 'test/viteEnv';

/**
 * Mixpanel **project token** (public client identifier for the browser SDK).
 * This is not a Mixpanel API secret / service account key — those must never
 * be shipped in the frontend. Injected via SSM/CI as VITE_*; unset skips init.
 */
export const MIXPANEL_PROJECT_TOKEN_ENV_KEY = 'VITE_MIXPANEL_PROJECT_TOKEN' as const;

const MIXPANEL_INIT_OPTIONS = {
  autocapture: true,
  track_pageview: true,
  record_sessions_percent: 100,
  record_heatmap_data: true,
} as const;

let hasInitialized = false;

function readMixpanelProjectToken(): string {
  const raw = getViteEnv()[MIXPANEL_PROJECT_TOKEN_ENV_KEY];
  return typeof raw === 'string' ? raw.trim() : '';
}

/**
 * Initializes Mixpanel once on app load.
 * Missing token or SDK errors are swallowed so analytics never blocks the app.
 */
export function initMixpanel(): boolean {
  if (hasInitialized || typeof window === 'undefined') {
    return hasInitialized;
  }

  const token = readMixpanelProjectToken();
  if (!token) {
    return false;
  }

  try {
    mixpanel.init(token, { ...MIXPANEL_INIT_OPTIONS });
    hasInitialized = true;
    return true;
  } catch {
    return false;
  }
}
